import * as React from "react";

const LinkInfo: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="-1 -1 16 16">
        <path
            fill="currentColor"
            d="M6.99999969,14 C9.50085914,14 11.8117481,12.6658072 13.0621781,10.5 C14.3126073,8.33419275 14.3126073,5.66580766 13.0621781,3.5 C11.8117481,1.33419275 9.50085914,0 6.99999969,0 C4.49914086,0 2.18825144,1.33419275 0.937821865,3.5 C-0.312607706,5.66580766 -0.312607706,8.33419275 0.937821865,10.5 C2.18825144,12.6658072 4.49914086,14 6.99999969,14 Z M5.90625,9.1875 L6.5625,9.1875 L6.5625,7.4375 L5.90625,7.4375 L5.25,7.4375 L5.25,6.125 L5.90625,6.125 L7.21875,6.125 L7.875,6.125 L7.875,6.78125 L7.875,9.1875 L8.09375,9.1875 L8.75,9.1875 L8.75,10.5 L8.09375,10.5 L5.90625,10.5 L5.25,10.5 L5.25,9.1875 L5.90625,9.1875 Z M7.875,5.25 L6.125,5.25 L6.125,3.5 L7.875,3.5 L7.875,5.25 Z"
        />
    </svg>
);

export default React.memo(LinkInfo);
